package org.zq.astrock_ai.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class LicenseRedeemRequestDto(
    val code: String = "",
    val deviceId: String = "",
)

@Serializable
data class LicenseStatusDto(
    val ok: Boolean,
    val message: String = "",
    val token: String = "",
    val deviceId: String = "",
    val plan: String = "",
    val planLabel: String = "",
    val expiresAtMs: Long = 0L,
    val expiresAtLabel: String = "",
)

@Serializable
data class LicenseRedeemResponseDto(
    val success: Boolean,
    val message: String = "",
    val token: String = "",
    val deviceId: String = "",
    val plan: String = "",
    val planLabel: String = "",
    val expiresAtMs: Long = 0L,
    val expiresAtLabel: String = "",
)

@Serializable
data class LicenseGenerateRequestDto(
    val plan: String = "",
    val count: Int = 1,
)

@Serializable
data class LicenseGenerateResponseDto(
    val success: Boolean,
    val message: String = "",
    val plan: String = "",
    val planLabel: String = "",
    val codes: List<String> = emptyList(),
)

@Serializable
data class SupportContactDto(
    val title: String = "",
    val wechat: String = "",
)

@Serializable
data class SupportContactListDto(
    val items: List<SupportContactDto> = emptyList(),
)
